import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchUnitZones, updateUnitZones } from "actions/Zones";
import ButtonContained from "components/ButtonContained";
import CheckboxInput from "components/CheckboxInput";
import LoadingIndicator from "components/LoadingIndicator";

const ZonesDetailModal = ({ uuDetail }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const unitZones = useSelector(state => state.zones.unitZones);
  const [editMode, setEditMode] = useState(false);
  const [editableZones, setEditableZones] = useState([]);

  useEffect(() => {
    dispatch(fetchUnitZones(uuDetail.unit.id));
  }, []);

  
  const handleZoneToggle = (uuid, checked) => {
    setEditableZones(prev =>
      prev.map(z => z.uuid === uuid ? { ...z, inZone: checked } : z)
    );
  };
  
  const handleEditClick = () => {
    const clonedZones = unitZones.zones.map(z => ({ ...z }));
    setEditableZones(clonedZones);
    setEditMode(true);
  };

  const handleSaveClick = () => {
    const selectedZones = editableZones.filter(z => z.inZone);
    if (selectedZones.length === 0) {
      // error handling for at least one zone
      return;
    }
    dispatch(updateUnitZones(
      {
        UnitID: uuDetail.unit.id,
        UnitUUID: uuDetail.unit.uuid,
        ZoneIds: selectedZones.map(z => z.id),
        ZoneUUIDs: selectedZones.map(z => z.uuid)
      }
    ));
    setEditMode(false);
  };

  const handleCancelClick = () => {
    setEditableZones([]);
    setEditMode(false);
  };

  const zonesToRender = editMode ? editableZones : unitZones?.zones || null;

  return (
    <div className="px-10 flex flex-col gap-6 pt-4 min-h-[300px]">
      {zonesToRender && <div className="flex flex-col gap-8 pt-2 flex-grow">
        {zonesToRender.map(z => {
          return (
            <div key={z.id} className="flex justify-between w-full">
              <p className="tw-desc-reg font-semibold whitespace-nowrap">{z.name}</p>
              <CheckboxInput
                id={`User-Zones-Edit-Checkbox-Zone-${z.uuid}`}
                dataCy={`User-Zones-Edit-Checkbox-Zone-${z.uuid}`}
                hideLabel={true}
                checked={z.inZone}
                align="right"
                disabled={!editMode}
                onChange={(checked) => {
                  handleZoneToggle(z.uuid, checked)
                }}
              />
            </div>
          )
        })}
      </div>}

      {!unitZones &&
        <div className="flex flex-col pt-4 items-center flex-grow">
          <LoadingIndicator />
        </div>
      }

      {unitZones && <div className="flex gap-2 justify-start">
        {!editMode && <ButtonContained
          id="User-Zones-Detail-Modal-Edit-Zones-Button"
          dataCy="User-Zones-Detail-Modal-Edit-Zones-Button"
          text={intl.formatMessage({ id: "comp.button.edit.zones" })}
          type="default"
          onClick={handleEditClick}
        />}
        {editMode && <ButtonContained
          id="User-Zones-Detail-Modal-Save-Zones-Button"
          dataCy="User-Zones-Detail-Modal-Save-Zones-Button"
          text={intl.formatMessage({ id: "comp.button.save.zones" })}
          type="default"
          onClick={handleSaveClick}
        />}
        {editMode && <ButtonContained
          id="User-Zones-Detail-Modal-Cancel-Save-Zones-Button"
          dataCy="User-Zones-Detail-Modal-Cancel-Save-Zones-Button"
          text={intl.formatMessage({ id: "comp.button.cancel" })}
          type="defaultOutline"
          onClick={handleCancelClick}
        />}
      </div>}
    </div>
  )
}

export default ZonesDetailModal;